/* eslint-disable @typescript-eslint/no-empty-function */
import { CloseIcon } from 'assets/icons/CloseIcon'
import { PieChart } from 'components/Chart/PieChart'
import { LineItem } from 'components/Dashboard/LineItem'
import { Title } from 'components/Dashboard/Title'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { DashboardCard, DCContent, P } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { groputDashboardItems } from 'utils/helpers'
import { WidgetEditOverlay } from '../Dashboard.styled'

export const WorkersWidget = ({
  modalOpen,
  removeWidget,
  onDragStart,
  onDragOver,
  onDragDrop,
}: IWidget) => {
  const { shifts } = useSelector((state: RootState) => state.dashboard)
  const { darkMode } = useSelector((state: RootState) => state.globals)
  const shiftsData = groputDashboardItems(shifts?.shifts)

  // Theme-aware colors
  const getColors = () => {
    if (!darkMode) {
      return [
        { start: '#FF6B6B', end: '#FF5252' }, // red
        { start: '#4CAF50', end: '#66BB6A' }, // green
        { start: '#FFD54F', end: '#FFEB3B' }, // yellow
        { start: '#42A5F5', end: '#64B5F6' }, // blue
        { start: '#AB47BC', end: '#BA68C8' }, // purple
        { start: '#FF9800', end: '#FFB74D' }, // orange
        { start: '#26A69A', end: '#4DB6AC' }, // teal
      ]
    } else {
      return [
        { start: '#A63222', end: '#E63B26' }, // red
        { start: '#1C6E11', end: '#2F8C19' }, // green
        { start: '#806500', end: '#B89000' }, // yellow
        { start: '#2C75A6', end: '#4A9ED1' }, // blue
        { start: '#8F39AF', end: '#A94BC2' }, // purple
        { start: '#FF7A26', end: '#FF7043' }, // orange
        { start: '#1A6F63', end: '#23877A' }, // teal
      ]
    }
  }

  const colors = getColors()

  const navigate = useNavigate()
  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => {
        onDragStart('workers', 1)
      }}
      onDrop={onDragDrop}
      onDragEnd={(e) => {
        e.preventDefault()
      }}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('workers')
      }}
      width='1fr'
      style={{ gridArea: 'workers', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('workers')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon white />
        </WidgetEditOverlay>
      )}
      <Title
        title='Employees'
        arrow
        onClick={() => !modalOpen && navigate('/dashboard/employees')}
      />
      <DCContent>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <PieChart
            data={shiftsData.map((item, index) => ({
              name: item.name,
              value: Number(item.value),
              color: colors[index],
            }))}
            size={180}
            showLabels={false}
            showValues={false}
          />
        </div>
        <LineItem
          borderTop
          title='Low Rated Workers'
          count={shifts?.lowRatedCount}
          noBottom
          numberOnly
        />
      </DCContent>
    </DashboardCard>
  )
}
